import NativeApplicationImg from "@assets/images/woman-showing-a-mobile-app-on-her-mobile-phone.avif";

export const data = {

    heading: "Why Choose Native App Development?",

    text: 'Choosing native is about performance insurance, it remains the gold standard for several critical reasons:',

    list: [
        { boldText: 'Zero Performance Compromises', text: 'Native code ensures superior speed and responsiveness for complex features like AR/VR, real-time data processing, high-fidelity gaming and complex apps.' },
        { boldText: 'Platform-Perfect UX', text: 'By utilizing native UI components, your application aligns flawlessly with platform-specific design guidelines, ensuring an intuitive user experience that drives higher retention.' },
        { boldText: 'Full Hardware Integration', text: 'Native apps access cameras, GPS, BLE (Bluetooth Low Energy), and haptic sensors without any bridges or workarounds.' },
        { boldText: 'Faster App Store Approvals', text: 'Because native apps meet Apple and Google’s guidelines flawlessly, they enjoy faster approval times and better credibility on the stores.' },
        { boldText: 'Security & Compliance', text: 'Native development allows for direct integration with hardware-backed Keystores and Secure Enclaves, making it the best choice for fintech and healthcare apps requiring HIPAA or high-level encryption.' },
    ]
    ,
    img: NativeApplicationImg,
    altText: 'A female artist showing her mobile app, for virtual art space, on her mobile phone.'

}